import React, { useEffect, useCallback, useState} from 'react';
import Colors from 'components/Colors.js';
import {getPacks} from 'packs/packs.js';
import {usePacks} from "components/selector2/usePacks.js";
import {
    setCreatingNewPack
} from 'actions/index.js';
import {
    SOUND_RATED,
    PRESET_RATED} from 'decentralized/xanadu/LinkTypes.js';
import {useFavorites} from "components/hooks/useFavorites.js";
import ConditionedCheckmark from "components/ConditionedCheckmark.js";
import {connect} from 'react-redux';

const colors = new Colors();

const ContentDropdown = ({
    setPackToSearch,
    setCreatingNewPack,
    dropdownPos,
    setDropdownPos,
    type= SOUND_RATED,
    isUnsourced,
    setIsSourcing,
    setIsTagging,
    content,
    contentHash,
    createNewTrack
}) => { 
    let {toggleFavorite, isFavorited} = useFavorites({type, contentHash, disabled: !dropdownPos});
    let [packs, setPacks] = useState([]);
    let {createNewPack, addToPack, packsIncludedIn} = usePacks(
        contentHash,
        dropdownPos,
        type === SOUND_RATED ? content : undefined,
        type === PRESET_RATED ? content: content);

    useEffect(() => {
        if (dropdownPos) {
            window.addEventListener("mousedown", hideContextMenu);
        } else {
            window.removeEventListener("mousedown", hideContextMenu);
        }
    }, [setDropdownPos, dropdownPos]);

    const hideContextMenu = useCallback(() => {
        setDropdownPos(undefined);
    }, [setDropdownPos]);

    useEffect(() => {
        if (dropdownPos) {
            getPacks().then(setPacks);
        }
    }, [dropdownPos, setPacks]);

    if (!dropdownPos) { return []; }

    let _packs1 = packs.filter(x => packsIncludedIn.some(y => y.packHash === x.packHash));
    let _packs2 = packs.filter(x => !packsIncludedIn.some(y => y.packHash === x.packHash));
    let _packs = [... _packs1, ... _packs2];
    let __packs = [];
    _packs.forEach(p => {
        if (!__packs.some(x => x.title === p.title)) {
            __packs.push(p);
        }
    });
    _packs = __packs;

    let typeName = type === SOUND_RATED ? " sample" : " preset";
    return (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{left: dropdownPos.x, top: dropdownPos.y}} className="sample-dropdown">
        <div onMouseDown={toggleFavorite} className="menu-item">
          {isFavorited ? "Unfavorite" + typeName : "Favorite" + typeName} <div className={isFavorited ? "heart favorited" : "heart"}/>
        </div>
        <div onMouseDown={() => setIsTagging(true)} className="menu-item">
          Tag {typeName}
        </div>
        {isUnsourced ?
         <div onMouseDown={() => setIsSourcing(true)} className="menu-item">
           Edit Source
         </div> : ''}
        <div onMouseDown={createNewTrack} className="menu-item">
          Create New Track
        </div>
        <div
          className="menu-item">
          Add to pack <div className="arrow-right"/>
          <div className="packs sample-dropdown">
            <div
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => {
                  setCreatingNewPack(content);
              }}
              className="menu-item new-pack">+ New Pack</div>
            {_packs.map(
                x =>
                    <div
                      onClick={(e) => e.stopPropagation()}
                      onMouseDown={(e) => {
                          if (!packsIncludedIn.some(y => y.packHash === x.packHash)) {
                              addToPack(x);
                          }
                          setDropdownPos(undefined);
                      }}
                      className="menu-item">
                      <div style={{backgroundColor: colors.getColorForHash(x.title)}} className="pack-thumb"/>
                      <div className="pack-title">{x.title}</div>
                      <ConditionedCheckmark
                        className="guilds-checkmark" 
                        condition={packsIncludedIn.some(y => y.packHash === x.packHash)}/>
                    </div>)}
            
          </div>
        </div>
        {_packs1.length > 0 ? 
         <div className="packs-included-in">
           {_packs1.map(
               x =>
                   <div
                     onClick={(e) => e.stopPropagation()}
                     onMouseDown={() => {
                       setPackToSearch(x);
                   }} className="menu-item">
                     <div style={{backgroundColor: colors.getColorForHash(x.title)}} className="pack-thumb"/>
                     <div className="pack-title">{x.title}</div>
                     <ConditionedCheckmark
                       className="guilds-checkmark" 
                       condition={packsIncludedIn.some(y => y.packHash === x.packHash)}/>
                   </div>)}
         </div> : ''}
      </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCreatingNewPack: m => dispatch(setCreatingNewPack(m)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentDropdown);
